import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { createStructuredSelector } from 'reselect';
import { HSAPaxContent } from './HotelStandalonePaxContent';
import { withPageContext, TrackingUtils, CurrentAccommodationSearchSessionStorage } from '../../../utils';
import { deleteRoom, updateRoom } from '../../../redux/currentSearch/actions';
import { PaxConstants, RoomsPaxProps } from '../../../models';
import { getDeleteRoomSelectorClassNames } from '../useRoomSelectorClassNames';

const KIDS_LENGTH_TRIGGER_TRACKING = 1;

export const HSAPaxSelector = ({
    deleteRoom,
    updateRoom,
    room,
    roomNumber,
    trackEvent,
    numPax,
    hasError,
    showRoomHeader,
    paxRestrictions,
    kidsAgeRange,
    isNative,
}) => {
    const { t } = useTranslation();

    const onClickDelete = () => {
        handleTracking(TrackingUtils.LABEL.roomAction({ action: 'remove' }));
        deleteRoom(room);
        CurrentAccommodationSearchSessionStorage.deleteRoom(room);
    };

    const handleTracking = (label) => {
        const action = TrackingUtils.ACTION.HOTELS;
        trackEvent({ action, label });
    };

    const onSelectKidAge = (id, selectedItem) => {
        const newRoom = { ...room };
        newRoom.kids[id] = selectedItem;
        updateRoom(newRoom);
        CurrentAccommodationSearchSessionStorage.setRooms(newRoom);
    };

    const onPaxChange = (partial) => {
        let newRoom = {};
        if (partial[PaxConstants.ADULTS]) {
            newRoom = { ...room, ...partial };
        } else {
            newRoom = { ...room };
            if (room.kids.length < partial.kids) {
                newRoom.kids.push(-1);
            } else {
                newRoom.kids.pop();
            }
        }

        if (newRoom.kids.length > KIDS_LENGTH_TRIGGER_TRACKING) {
            handleTracking(TrackingUtils.LABEL.maxKidsPerAdult());
        }
        updateRoom(newRoom);
        CurrentAccommodationSearchSessionStorage.setRooms(newRoom);
    };

    const deleteRoomClass = getDeleteRoomSelectorClassNames();

    return (
        <>
            {showRoomHeader &&(
                <div className={deleteRoomClass.wrapper}>
                    <div className="odf-flex-container-row odf-flex-container-gutter-lg">
                        <div className="odf-flex-item dp-pax-selector-header">
                            {t('roomSelector.header')} {roomNumber + 1}
                        </div>
                        {roomNumber > 0 && (
                            <span
                                className={deleteRoomClass.icon}
                                onClick={onClickDelete}
                            />
                        )}
                    </div>
                </div>
            )}
            <HSAPaxContent
                pax={room}
                paxRestrictions={paxRestrictions}
                roomId={room.id}
                onChange={onPaxChange}
                onSelectKidAge={onSelectKidAge}
                showKidError={hasError}
                isNative={isNative}
                numPax={numPax}
                kidsAgeRange={kidsAgeRange}
            />
        </>
    );
};

HSAPaxSelector.propTypes = {
    room: RoomsPaxProps.isRequired,
    roomNumber: PropTypes.number.isRequired,
    deleteRoom: PropTypes.func.isRequired,
    updateRoom: PropTypes.func.isRequired,
    trackEvent: PropTypes.func.isRequired,
    numPax: PropTypes.number.isRequired,
    hasError: PropTypes.bool,
    showRoomHeader: PropTypes.bool,
    kidsAgeRange: PropTypes.arrayOf(PropTypes.number),
    isNative: PropTypes.bool,
};

HSAPaxSelector.defaultProps = {
    hasError: false,
    isNative: false,
};

const ConnectedHSAPaxSelector = connect(createStructuredSelector({}), {
    deleteRoom,
    updateRoom,
})(HSAPaxSelector);

export default withPageContext(ConnectedHSAPaxSelector);
